import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__list_base_generic } from '../../_primitives/list/FIELD__list_base_generic';
import { FIELD__base } from '../FIELD__base';

export function DECORATOR__data__do_not_populate_from_linked(method_original: any, context: ClassMethodDecoratorContext) {
  // Return a new function that replaces the old one
  return function (this: FIELD__base, ...args: any[]) {
    assert_instanceof(this, FIELD__base);

    this.meta.data__populate_from_linked = false;

    if (this instanceof FIELD__list_base_generic) {
      this.item_meta.set('data__populate_from_linked', false);
    }

    return method_original.apply(this, args);
  };
}
